<template>
  <div v-if="!hasData" class="flex items-center justify-center h-full" :style="{ minHeight }">
    <p class="text-sm text-gray-600">ไม่มีข้อมูล</p>
  </div>
  <ul v-else class="space-y-4" data-progress-export>
    <li v-for="item in items" :key="item.label">
      <div class="flex items-center justify-between text-sm gap-3">
        <span>{{ item.label }}</span>
        <span class="text-gray-600 flex-none text-xs">
          {{ item.percent }}% <template v-if="item.value">({{ formatVal(item.value) }} {{ unit }})</template>
        </span>
      </div>
      <div class="h-2.5 bg-[#E7E7E7] rounded-sm mt-2 overflow-hidden">
        <div class="h-full rounded-sm" :style="{ width: item.percent + '%', backgroundColor: item.color || color }"></div>
      </div>
    </li>
  </ul>
</template>

<script setup>
import { globalNumDecFixed } from "@/utils/format-number";
import { computed } from "vue";

const props = defineProps({
  items: { type: Array, default: () => [] }, // [{ label, percent, value }]
  color: { type: String, default: "#1C4E80" },
  unit: { type: String, default: "คน" },
  minHeight: { type: String, default: "240px" },
});
const hasData = computed(() => props.items?.length > 0 && props.items.some((item) => Number(item.percent) > 0));
const formatVal = (v) => (typeof v === "number" ? globalNumDecFixed(v) : v);
</script>
